/* eslint-disable @typescript-eslint/no-explicit-any */
import { uniqBy } from 'lodash';
import { gql } from 'apollo-boost';
import { useQueryRefresh } from '..';
import { removeConnectionsMemoized } from '..';

export const extractTags = (tags: (string | string[])[]): string[] => {
  const result: string[] = [];

  for (const tag of tags) {
    if (typeof tag === 'string' && tag.startsWith('{') && tag.endsWith('}')) {
      try {
        const parsed = JSON.parse(tag.replace(/'/g, '"'));
        const newTag = parsed.tag?.trim();
        if (newTag) {
          result.push(newTag);
        }
      } catch {
        continue;
      }
    } else if (typeof tag === 'string') {
      const trimmedTag = tag.trim();
      if (trimmedTag) {
        result.push(trimmedTag);
      }
    }
  }

  return result;
};

const query = gql`
  query($investmentId: ID) {
    allInvestmentTags(filters: { investmentId: $investmentId }) {
      edges {
        node {
          tag
          investmentId
        }
      }
    }
  }
`;

const queryAll = gql`
  query {
    allInvestmentTags {
      edges {
        node {
          tag
          investmentId
        }
      }
    }
  }
`;

export const useDonationTags = (investmentId: number) => {
  const { data: rawData, refresh, isLoading } = useQueryRefresh(query, {
    investmentId,
  });
  const data =
    (rawData as any)?.allInvestmentTags?.edges.length > 0
      ? removeConnectionsMemoized((rawData as any)?.allInvestmentTags)
      : [];
  return { data, refresh, isLoading };
};

export const useAllDonationTags = () => {
  const { data: rawData, refresh, isLoading } = useQueryRefresh(queryAll);
  const data =
    (rawData as any)?.allInvestmentTags?.edges.length > 0
      ? uniqBy(
          removeConnectionsMemoized((rawData as any)?.allInvestmentTags),
          'tag',
        ).map(({ tag }: any) => tag)
      : [];
  return { data: extractTags(data), refresh, isLoading };
};
